import { render, staticRenderFns } from "./zhishichanquanri.vue?vue&type=template&id=8302bfde&scoped=true&"
import script from "./zhishichanquanri.vue?vue&type=script&lang=js&"
export * from "./zhishichanquanri.vue?vue&type=script&lang=js&"
import style0 from "./zhishichanquanri.vue?vue&type=style&index=0&id=8302bfde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8302bfde",
  null
  
)

export default component.exports